export default __webpack_public_path__ + "static/media/bikersHouse.998aa6a1.png";